import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Link } from "react-router-dom";


const languageMap: any = {
  en: { label: "English", dir: "ltr", active: true },
  hn: { label: "हिन्दी", dir: "ltr", active: false },
  bn: { label: "বাংলা", dir: "ltr", active: false },
  kn: { label: "ಕನ್ನಡ", dir: "ltr", active: false },
  ta: { label: "தமிழ்", dir: "ltr", active: false }, 

};

const LanguageSelectMobile = (props: any) => {
    const selected = (localStorage.getItem("i18nextLng") || "en").split('-')[0];
    const { t } = useTranslation();
    const handleLangChange = (e: any, val: any) => {
        e.preventDefault();
        i18next.changeLanguage(val);
        props.onClick();
    }
    useEffect(()=> {
    if(selected){
      i18next.changeLanguage(selected);
    }
  },[selected])
    return (
        <Link to={"#"} className="h_dropdown"><i className="fa fa-language" style={{ marginRight: "10px" }}></i><span>{t("select_language")}<i className="fa fa-angle-down fa-xs ml-2"></i></span>
            <div className="h_dropdown-menu">
                {Object.keys(languageMap)?.map((item, i) => (
                    <>
                        <div><a href="#" onClick={(e: any) => handleLangChange(e, item)}>{languageMap[item].label}</a></div>
                        {(Object.keys(languageMap)?.length - 1) > i && <hr />}
                    </>
                ))}
            </div>
        </Link>
    );
};

export default LanguageSelectMobile;
